<template>
  <header class="status__header">
    <h2 v-if="containsSomeConflicts" class="status__header__title">
      {{ $t(`${namespace}.containsSomeConflicts`) }}
    </h2>

    <h2 v-if="containsSomeErrors" class="status__header__title">
      {{ $t(`${namespace}.containsSomeErrors`) }}
    </h2>

    <h2 v-if="withoutConflicts" class="status__header__title">
      {{ $t(`${namespace}.withoutConflicts`) }}
    </h2>

    <Label
      :value="data.total"
      :colored="withoutConflicts"
      :success="withoutConflicts"
      :icon="withoutConflicts"
    />

    <p class="status__header__text">
      {{ $t(`${namespace}.spreadsheetRegistrationRequests`) }}
    </p>

    <p
      v-if="withoutConflicts"
      v-html="$t(`${namespace}.proceedTextClick`)"
      class="status__header__disclaimer"
    />
  </header>
</template>

<script>
import Label from 'components/bulkImport/Label'

export default {
  name: 'StatusHeader',
  props: {
    data: {
      type: Object,
      required: true
    },
    solvedConflicts: {
      type: Number,
      default: 0
    }
  },
  components: {
    Label
  },
  computed: {
    containsSomeConflicts () {
      return (this.data.conflicts || this.solvedConflicts) && !this.data.errors
    },
    containsSomeErrors () {
      return !(this.data.conflicts || this.solvedConflicts) && this.data.errors
    },
    withoutConflicts () {
      return !this.solvedConflicts && ((this.data.success === this.data.total) || (this.data.updates === this.data.total))
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.status.header'
    }
  }
}
</script>

<style lang="scss" scoped>
.status__header {
  text-align: center;
}

.status__header__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 700;
  margin: 24px 0;
}

.status__header__text {
  color: $gray-6;
  margin: 16px auto 0;

  @media (min-width: 768px) {
    max-width: 160px;
  }
}

.status__header__disclaimer {
  color: $gray-6;
  margin: 32px 0 16px;
}
</style>
